import { Switch, FormControlLabel, Typography } from '@mui/material';
import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from "react";
import { Col, Drawer, Row } from "antd";
import ClassCard from "components/ClassCard";
import SentryWrap from "components/Sentry";
import ClassForm from "features/forms/Class";
import FlatList from "flatlist-react";
import { connect, useDispatch } from "react-redux";
import {
  handleListUserClasses,
  handleUpdateClasseOrder,
} from "store/userClasses/thunks";
import styled from "styled-components";
import { filter, find, flatMap } from "lodash";
import COLOR from "utils/constants/color";
import { useLocation, useNavigate } from "react-router-dom";
import { Star } from '@mui/icons-material';
import Tag from "components/Tag";
import { handleUserClassesSync } from "store/classlink/thunks";
import { groupLinkedSection } from "utils/lib/ebookHelper";
import { useDrag, useDrop, useDragLayer } from "react-dnd";
import { handleSyncSchoologyClasses } from "store/schoology/thunks";

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


// Individual card
function SortableCard({ item }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  return (
    <OuterWrapper ref={setNodeRef} style={{ opacity: 1, ...style }} {...attributes} {...listeners}>
      <ClassCard key={item?.id} classInfo={item} />
    </OuterWrapper>
  );
}


const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
const Navigation = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  list-style-type: none;
  margin: 0px;
  padding: 0px;
`;
const StyledDrawer = styled(Drawer)`
  @media (min-width: 1367px) {
    // display: none;
  }
`;
const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
const Note = styled.span`
  color: ${COLOR.black400};
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;
const ButtonClass = styled.button`
  background: #582f81;
  color: #ffffff;
  font-size: 18px;
  width: 150px;
  height: 45px;
  margin-right: 24px;
  margin-top: 24px;
  border-radius: 8px !important;
  padding: 9px 7px !important;
  border: 0;
  &:hover {
    background: #582f81e3 !important;
  }
`;
const SectionTitle = styled.div`
  font-size: 14px;
  color: #ffffff;
  background: ${COLOR.tabActive};
  padding: 4px 8px;
  border-radius: 6px !important;
  cursor: pointer;
  position: absolute;
  top: -15px;
  padding-left: 24px;
  padding-right: 24px;
  font-weight: bold;
  letter-spacing: 0.5px;
`;
const OuterWrapper = styled.div`
    @media only screen and (max-width: 576px) {
    margin: 0px 12px;
    ${"" /* width: calc(100% - 24px); */}
  }
  @media only screen and (min-width: 576px) and (max-width: 992px) {
    margin: 0px 12px;
    ${"" /* width: calc(50% - 24px); */}
  }
  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    margin: 0px 12px;
    ${"" /* width: calc(33.33% - 24px); */}
  }
  @media only screen and (min-width: 1200px) {
    margin: 0px 12px;
    ${"" /* width: calc(25% - 24px); */}
  }
`;

const Label = styled(Typography)`
  font-size: 18px;
  color: #582f81;
`;

function ToggleClasses({ showHiddenClasses, setShowHiddenClasses }) {
  const handleToggle = (event) => {
    setShowHiddenClasses(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={showHiddenClasses}
          onChange={handleToggle}
          color="primary"
        />
      }
      label={
        <Label>
          {showHiddenClasses ? "Archived classes " : "Active classes"}
        </Label>
      }
      labelPlacement="start"
      style={{ margin: 24 }}
    />
  );
}

const ItemType = "CARD";

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
};

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none",
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
    opacity: 0.9,
    maxWidth: 400,
  };
}

const CustomDragLayer = () => null;

function DragReorderList() { return null; }

const DraggableCard = ({ item, index, moveCard, setDragOverIndex }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem, monitor) => {
      if (!ref.current) {
        return;
      }
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveCard(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    },
    drop: (draggedItem) => {
      moveCard(draggedItem.index, index);
    },
  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: ItemType,
    item: { id: item.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));
  useEffect(() => {
    const emptyImage = new Image();
    emptyImage.src = "";
    emptyImage.style.opacity = 0;
    preview(emptyImage);
  }, [preview]);
  return (
    <OuterWrapper ref={ref} style={{ opacity: 1 }}>
      <ClassCard key={item.id} classInfo={item} />
    </OuterWrapper>
  );
};

function LearnScreen({
  classActivities,
  classQuizzes,
  currentClass,
  currentOrg,
  currentUser,
  userClasses,
  classUsers,
  classNotes,
  booksAllList,
  fromDrawer,
  setVisible,
  openMenuClass,
  onCloseMenuBook = () => {},
}) {
  const [classDrawer, toggleClassDrawer] = useState(false);
  const isSchoologyUser = !!(currentUser && currentUser.schoologyid);
  const isCleverUser = !!(currentUser && currentUser.cleverId);
  const isCanvasUser = !!(currentUser && currentUser.canvas_id);
  const isGoogleUser = !!(currentUser && currentUser.googleId);
  const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
  const isUserFromOtherPlatform =
    isSchoologyUser ||
    isCleverUser ||
    isGoogleUser ||
    isClassLinkuser ||
    isCanvasUser;
  const [classes, setClasses] = useState(
    filter(userClasses, (k) => !k.archived)
  );
  const [showHiddenClasses, setShowHiddenClasses] = useState(false);
  
  							  const navigate = useNavigate();
  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const [non_crossed_courses, setNonCrossedCourses] = useState([]);
  const [archivedClasses, setArchivedClasses] = useState([]);
  const [crossed_courses_reordered, setCrossedCoursesReordered] = useState([]);
  const [linked_groups_reordered, setLinkedGroupsReordered] = useState({});
  const crossed_courses = useMemo(
    () => filter(classes, (k) => k.canvas_cross_course_id),
    [classes]
  );
  const moveLinkedCard = (sectionKey, fromIndex, toIndex) => {
    const baseItems = linked_groups_reordered[sectionKey] && linked_groups_reordered[sectionKey].length
      ? linked_groups_reordered[sectionKey]
      : [...(linked_classes[sectionKey] || [])].sort((a, b) => (a.order || 0) - (b.order || 0));
    const updatedItems = [...baseItems];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    setLinkedGroupsReordered((prev) => ({ ...prev, [sectionKey]: updatedItems }));
    setTimeout(() => {
      dispatch(
        handleUpdateClasseOrder(
          updatedItems.map((a, ind) => ({ id: a.id, order: ind }))
        )
      );
    }, 1000);
  };
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [update_done, setUpdateDone] = useState(0);
  const [crossed_update_done, setCrossedUpdateDone] = useState(0);
  const is_touch = useMemo(() => isTouchDevice(), []);
  useEffect(()=>{
    const groupByLinkSection = groupLinkedSection(classes , isSchoologyUser)
    const flat_groupByLinkSection = flatMap(groupByLinkSection, k => k)
        const non_crossed_courses_item = filter(classes, k =>{
            const is_in_group = find(flat_groupByLinkSection, flt => flt.id == k.id)
        return !k.canvas_cross_course_id && !is_in_group
    })
    setNonCrossedCourses(non_crossed_courses_item.sort((a,b) => a.order - b.order))
},[classes])

  // Initialize crossed_courses_reordered when crossed_courses changes
  useEffect(() => {
    if (crossed_courses.length > 0) {
      const sortedCourses = [...crossed_courses].sort((a, b) => (a.order || 0) - (b.order || 0));
      // console.log('Initializing crossed courses:', sortedCourses);
      setCrossedCoursesReordered(sortedCourses);
    } else {
      setCrossedCoursesReordered([]);
    }
  }, [crossed_courses]);

  // Debug effect to see what's happening
  useEffect(() => {
    // console.log('Crossed courses changed:', crossed_courses);
    // console.log('Crossed courses reordered:', crossed_courses_reordered);
  }, [crossed_courses, crossed_courses_reordered]);

  const location = useLocation();
  const handleNonCrossedDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = non_crossed_courses.findIndex((i) => i.id === active.id);
    const newIndex = non_crossed_courses.findIndex((i) => i.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const reordered = arrayMove(non_crossed_courses, oldIndex, newIndex);
    setNonCrossedCourses(reordered);
    dispatch(
      handleUpdateClasseOrder(
        reordered.map((a, ind) => ({ id: a.id, order: ind }))
      )
    );
  };

  const handleCrossedDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = crossed_courses_reordered.findIndex((i) => i.id === active.id);
    const newIndex = crossed_courses_reordered.findIndex((i) => i.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const reordered = arrayMove(crossed_courses_reordered, oldIndex, newIndex);
    setCrossedCoursesReordered(reordered);
    dispatch(
      handleUpdateClasseOrder(
        reordered.map((a, ind) => ({ id: a.id, order: ind }))
      )
    );
  };
  const moveCard = (fromIndex, toIndex) => {
    const updatedItems = [...non_crossed_courses];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    setNonCrossedCourses(updatedItems);
    setTimeout(() => {
      setUpdateDone((i) => i + 1);
    }, 1000);
  };

  const moveCrossedCard = (fromIndex, toIndex) => {
    if (fromIndex === toIndex) return;
    
    // console.log('Moving crossed card from', fromIndex, 'to', toIndex);
    const updatedItems = [...crossed_courses_reordered];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    // console.log('Updated crossed courses:', updatedItems);
    setCrossedCoursesReordered(updatedItems);
    setTimeout(() => {
      setCrossedUpdateDone((i) => i + 1);
    }, 1000);
  };

  const renderItem = (item, index) => {
    return (
      <OuterWrapper>
        <ClassCard key={item.id} classInfo={item} />
      </OuterWrapper>
    );
  };
  useEffect(() => {
    onClassDataChange();
  }, [userClasses, showHiddenClasses]);
  useEffect(() => {
    if (Array.isArray(non_crossed_courses) && update_done > 0) {
      dispatch(
        handleUpdateClasseOrder(
          non_crossed_courses.map((a, ind) => ({ id: a.id, order: ind }))
        )
      );
    }
  }, [update_done, dispatch, non_crossed_courses]);

  useEffect(() => {
    if (Array.isArray(crossed_courses_reordered) && crossed_update_done > 0) {
      dispatch(
        handleUpdateClasseOrder(
          crossed_courses_reordered.map((a, ind) => ({ id: a.id, order: ind }))
        )
      );
    }
  }, [crossed_update_done, dispatch, crossed_courses_reordered]);
  useEffect(() => {
    if (currentUser && currentUser.classlinkid) {
      handleUserClassesSync(
        currentUser.classlinkid,
        currentUser.classlinkTenantId
      );
    }
  }, [currentUser]);
  useEffect(() => {
    if (currentUser && currentUser?.schoologyid) {
      handleSyncSchoologyClasses(currentUser?.schoologyid);
    }
  }, [currentUser]);
  const onClassDataChange = () => {
    setArchivedClasses(filter(userClasses, (k) => k.archived));
    setClasses(filter(userClasses, (k) => !k.archived));
  };
  const getClass = async () => {
    if (currentUser && currentUser.id) {
      await dispatch(handleListUserClasses(currentUser.id));
    }
    toggleClassDrawer(false);
  };
  const redirectToHome = () => {
    navigate(`/admin/class?view=home`);
  };
  useEffect(() => {
    if (userClasses && userClasses.length == 0) {
      if (isUserFromOtherPlatform) {
        redirectToHome();
      } else {
        toggleClassDrawer(true);
      }
    }
  }, [userClasses]);
  const archiveClasses = filter(userClasses, (k) => k.archived);
  const archiveCount =
    archiveClasses.length > 0 ? `(${archiveClasses.length})` : "";
  const archiveTxt = `Archived Classes ${archiveCount}`;
  const linked_classes = groupLinkedSection(classes , isSchoologyUser);
  const has_link =
    crossed_courses.length > 0 || Object.keys(linked_classes).length > 0;

  useEffect(() => {
    const classNames = ["overflow-hidden"];

    if (classDrawer) {
      document.body.classList.add(...classNames);
    } else {
      document.body.classList.remove(...classNames);
    }
    return () => {
      document.body.classList.remove(...classNames);
    };
  }, [classDrawer]);

  useEffect(() => {
    onCloseMenuBook();
  }, [location.key]);

  useLayoutEffect(() => {
      const handleResize = () => {
          onCloseMenuBook();
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: { distance: 5 },
      })
    );
  
  return (
    <>
      <Drawer
        height="100%"
        onClose={() => {
          toggleClassDrawer(false);
          setData({});
        }}
        placement="top"
        open={classDrawer}
        key="classNew"
        className="addNewDrawer"
      >
        <CenterContainer>
          <SentryWrap>
            {classDrawer && (
              <ClassForm
                data={data}
                dataBooks={{}}
                listBooks={booksAllList}
                setData={setData}
                currentOrg={currentOrg}
                currentUser={currentUser}
                currentClass={currentClass}
                classUsers={classUsers}
                userClasses={userClasses}
                onClosed={(hasClassLoad, classId) => {
                  setData({});
                  getClass(hasClassLoad, classId);
                  toggleClassDrawer(false);
                }}
              />
            )}
          </SentryWrap>
        </CenterContainer>
      </Drawer>
      <StyledDrawer
        placement={"right"}
        onClose={onCloseMenuBook}
        open={openMenuClass}
        className="HeaderMenuMObileClass"
        forceRender
      >
        <Navigation className="1111 mobileMenuSection">
          <Row className={`${!fromDrawer && "teacherHm"}`}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Row
                className="techrColectBtn"
                style={{ padding: "0px 0 60px 0" }}
              >
                {!isUserFromOtherPlatform && (
                  <ButtonClass
                    onClick={() => {
                      setVisible(false);
                      toggleClassDrawer(true);
                    }}
                  >
                    Create classes
                  </ButtonClass>
                )}
                <ToggleClasses
                  setShowHiddenClasses={setShowHiddenClasses}
                  showHiddenClasses={showHiddenClasses}
                />
              </Row>

              {showHiddenClasses ? (
                <Row style={{ marginBottom: 24, marginTop: -50 }}>
                  <Tag height={20} bgColor={COLOR.redishpink}>
                    <Star
                      style={{
                        height: "12px",
                        margin: "-1px 4px 0px 0px",
                        width: "12px",
                      }}
                    />{" "}
                    NOTE
                  </Tag>
                  <Note style={{ color: COLOR.black100 }}>
                    These are hidden classes.
                  </Note>
                </Row>
              ) : (
                <Row style={{ marginBottom: 24, marginTop: -50 }}>
                  <Tag height={20} bgColor={COLOR.redishpink}>
                    <Star
                      style={{
                        height: "12px",
                        margin: "-1px 4px 0px 0px",
                        width: "12px",
                      }}
                    />{" "}
                    NOTE
                  </Tag>
                  <Note style={{ color: COLOR.black100 }}>
                    You can drag and reorganize your classes as needed.
                  </Note>
                </Row>
              )}
              
              {!showHiddenClasses && Object.keys(linked_classes).length > 0 ? (
                <Row gutter={[40, 30]}>
                  {Object.keys(linked_classes).map((key, index) => {
                    const has_more_classes = linked_classes[key]?.length > 1;
                    const groupItems = (linked_groups_reordered[key] && linked_groups_reordered[key].length
                      ? linked_groups_reordered[key]
                      : [...(linked_classes[key] || [])].sort((a, b) => (a.order || 0) - (b.order || 0)));
                    const handleLinkedDragEnd = (event) => {
                      const { active, over } = event;
                      if (!over || active.id === over.id) return;
                      const oldIndex = groupItems.findIndex((i) => i.id === active.id);
                      const newIndex = groupItems.findIndex((i) => i.id === over.id);
                      if (oldIndex === -1 || newIndex === -1) return;
                      moveLinkedCard(key, oldIndex, newIndex);
                    };
                    return (
                      <div
                        key={key}
                        className={`teacherHmInr ${
                          has_more_classes ? "cross-section-teacher-home" : ""
                        }`}
                        style={{
                          display: "flex",
                          gap: "50px",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        {has_more_classes ? (
                          <SectionTitle>{"Linked section"}</SectionTitle>
                        ) : null}
                        {groupItems && groupItems.length > 0 ? (
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleLinkedDragEnd}
                            id={`linked-group-${key}`}
                          >
                            <SortableContext items={groupItems.map((c) => c.id)} strategy={rectSortingStrategy}>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                                  gap: "20px",
                                }}
                              >
                                {groupItems.map((c) => (
                                  <SortableCard key={c.id} item={c} />
                                ))}
                              </div>
                            </SortableContext>
                          </DndContext>
                        ) : (
                          <div>
                            {showHiddenClasses ? `No Archived classes` : `No Class found!`}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Row>
              ) : null}

              {!showHiddenClasses && crossed_courses.length > 0 ? (
                <Row
                  className={`teacherHmInr ${
                    crossed_courses.length > 1
                      ? " cross-section-teacher-home"
                      : ""
                  }`}
                  //gutter={[40, 30]}
                  style={{ gap: "50px", flexWrap: "wrap", width: "100%", paddingLeft: '10px', paddingRight: '10px' }}
                >
                  {crossed_courses.length > 1 ? (
                    <SectionTitle>Cross-listed</SectionTitle>
                  ) : null}
                  <div
                    style={{
                      display: "grid",
                      flexWrap: "wrap",
                      rowGap: "50px",
                      width: "100%",
                    }}
                  >
                    {crossed_courses_reordered && crossed_courses_reordered.length > 0 ? (
                      <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleCrossedDragEnd}
                        id="crossed-courses-dnd"
                      >
                        <SortableContext items={crossed_courses_reordered.map((c) => c.id)} strategy={rectSortingStrategy}>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                              gap: "50px",
                            }}
                          >
                            {crossed_courses_reordered.map((c) => (
                              <SortableCard key={c.id} item={c} />
                            ))}
                          </div>
                        </SortableContext>
                      </DndContext>
                    ) : (
                      <div>
                        {showHiddenClasses
                          ? `No Archived classes`
                          : `No Class found!`}
                      </div>
                    )}
                  </div>
                  {crossed_courses_reordered && crossed_courses_reordered.length > 0 && (
                    <CustomDragLayer />
                  )}
                </Row>
              ) : null}


              {showHiddenClasses ? (
                <Row
                  className="teacherHmInr non-cross-section-teacher-home"
                  style={{ gap: "50px", flexWrap: "wrap", width: "100%" }}
                >
                  <div
                    style={{
                      display: "grid",
                      flexWrap: "wrap",
                      rowGap: "50px",
                      width: "100%",
                    }}
                  >
                    <FlatList
                      list={archivedClasses}
                      renderItem={renderItem}
                      renderWhenEmpty={() => <div>{`No Archived classes`}</div>}
                      sortBy={["id"]}
                    />
                  </div>
                </Row>
              ) : null}


              {!showHiddenClasses && non_crossed_courses.length > 0 ? (
                <Row
                  className="teacherHmInr non-cross-section-teacher-home"
                  style={{
                    marginTop: has_link > 0 ? 50 : 0,
                    padding: has_link > 0 ? 0 : 0,
                    gap: "50px",
                    flexWrap: "wrap",
                  }}
                >
                  <>
                    <div
                      style={{
                        display: "grid",
                        flexWrap: "wrap",
                        rowGap: "50px",
                        width: "100%",
                      }}
                    >
                      <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleNonCrossedDragEnd}
                        id="non-crossed-courses-dnd"
                      >
                        <SortableContext items={non_crossed_courses.map((c) => c.id)} strategy={rectSortingStrategy}>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                              gap: "50px",
                            }}
                          >
                            {non_crossed_courses.map((item) => (
                              <SortableCard key={item?.id} item={item} />
                            ))}
                          </div>
                        </SortableContext>
                      </DndContext>
                    </div>
                    <CustomDragLayer />
                  </>
                </Row>
              ) : null}

            </Col>
          </Row>
        </Navigation>
      </StyledDrawer>
    </>
  );
}

const mapStateToProps = (state) => ({
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  currentClass: state.currentClass,
  currentOrg: state.currentOrg,
  currentUser: state.currentUser,
  userClasses: state.userClasses,
  booksAllList: state.booksAllList,
  classUsers: state.classUsers,
  classNotes: state.classNotes,
});

export default connect(mapStateToProps, null)(LearnScreen);
